import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"com-pc-card rw-number"},[_c(VCol,{staticClass:"com-pc-card-header rw-header"},[_c('span',{staticClass:"com-pc-card-title"},[_vm._v("発表号数")])]),_c(VCol,{staticClass:"white"},_vm._l((_vm.selectedRwDetail.rwBase),function(item,index){return _c('span',{key:index},[_c(VBtn,{staticClass:"btn_on mr-1 ml-1",class:{
          btn_on: _vm.selectedAnnIdx == index,
          btn_off: _vm.selectedAnnIdx != index,
        },attrs:{"outlined":"","x-small":"","fab":"","color":"indigo"},on:{"click":function($event){return _vm.selectAnnIdx(index)}}},[_vm._v(_vm._s(item.annNo))])],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }